import Dialog from './Dialog';

export default Dialog;


// WEBPACK FOOTER //
// /src/components/UiComponents/Dialog/index.js